import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from "react-router-dom";
import { Button, Card, Row, Col } from 'react-bootstrap';
import '../../../assets/scss/users.scss';
import { Icon } from '../widgets';
import { usePermission } from '../../helpers/common';
import {
    getRoleList, getUserList, getFarmList, getAuthList, getAuthProviderList,
    getRolePermissionList, getControllerList
} from '../../actions/users';
import { getOEMMakeList } from '../../actions/oem';
import UserForm from './Common/UserForm';
import UserList from './UserList/UserList';
import UserRoleList from './UserRoleList/UserRoleList';
import { SubNav } from '../layout/submenu';
const Users = (props) => {
    const { actions, farmId } = props;
    const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const [activeTab, setActiveTab] = useState(2);

    useEffect(() => {
        actions.getUserList(true);
        actions.getRoleList(() => actions.getRolePermissionList());
        actions.getFarmList();
        actions.getAuthProviderList();
        actions.getControllerList();
        actions.getOEMMakeList();
    }, []);

    const allow = usePermission();
    const isAllowCreate = allow("user", "create") ? true : false;

    return <>
        <Col className="users-container">
            <Card className="users-card animate animate__fadeIn">
                <Card.Header className="users-card-header" >
                    <Card.Title >{activeTab === 1 ? "Users" : "Roles"}
                        <Button
                            className='btn btn-sm float-right'
                            variant='danger'
                            onClick={() => {
                                const url = `/home/farm/${farmId}/map`;
                                history.push(url);
                            }}>
                            <i className='fa fa-times-circle mr-1' />
                            Cancel
                        </Button>

                        <span className={'split float-right '}>
                            <SubNav.Divider className={'splitter'} />
                        </span>

                        {activeTab !== 1 && isAllowCreate && <Button
                            variant="success"
                            size="sm"
                            className="float-right"
                            onClick={() => setShowModal(true)}>
                            <Icon className="fa fa-plus"></Icon> Add User</Button>}


                    </Card.Title>
                </Card.Header>
                <Card.Body className="users-card-body" >
                    <Row className="m-0 h-100">
                        <div className="user-menus">
                            <Row onClick={() => setActiveTab(1)} className={`user-menu-item pl-1 ${activeTab === 1 ? 'active' : ''}`}>
                                <Col className="p-0" style={{ textAlign: 'center' }} lg={2} md={2} sm={2}>
                                    <Icon className="fa fa-users" />
                                </Col>
                                <Col className="p-0" lg={10} md={10} sm={10}>Roles</Col>
                            </Row>
                            <Row onClick={() => setActiveTab(2)} className={`user-menu-item pl-1 ${activeTab === 2 ? 'active' : ''}`}>
                                <Col className="p-0" style={{ textAlign: 'center' }} lg={2} md={2} sm={2}>
                                    <Icon className="fa fa-user" />
                                </Col>
                                <Col className="p-0" lg={10} md={10} sm={10}>Users</Col>
                            </Row>
                            <Row onClick={() => setActiveTab(3)} className={`user-menu-item pl-1 ${activeTab === 3 ? 'active' : ''}`}>
                                <Col className="p-0" style={{ textAlign: 'center' }} lg={2} md={2} sm={2}>
                                    <i className="icons icon-customers" style={{ fontSize: "18px" }}></i>
                                </Col>
                                <Col className="p-0" lg={10} md={10} sm={10}>Customers</Col>
                            </Row>
                        </div>
                        <div className={`user-body ${activeTab !== 1 && "p-4"}`}>
                            {activeTab === 1 ? <UserRoleList /> : <UserList isCustomerList={activeTab === 3} />}
                        </div>
                    </Row>
                </Card.Body>
            </Card>
        </Col>
        {showModal && <UserForm onHide={() => setShowModal(false)} />}
    </>
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        getRoleList, getUserList, getFarmList, getAuthList, getAuthProviderList,
        getRolePermissionList, getControllerList, getOEMMakeList
    }, dispatch)
});

const mapStateToProps = state => ({
    farmId: state.farm.currentFarm.farm_uuid,
});

export default connect(mapStateToProps, mapDispatchToProps)(Users);